"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableBody.default;
  }
});

var _TableBody = _interopRequireDefault(require("./TableBody"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/TableBody/index.js
 ** module id = 44
 ** module chunks = 0
 **/